import { SyntheticEvent } from 'react'

import { AppziEventParamsTypes, AppziSurveyIdType } from './types'
const isProduction = process.env.NODE_ENV === 'production'

export const InitializeAppzi = (token: string) => {
  if (!token) {
    return
  }

  if (!document.querySelector(`script[src="https://w.appzi.io/w.js?token=${token}"]`)) {
    const script = document.createElement('script')
    script.src = `https://w.appzi.io/w.js?token=${token}`
    script.async = true
    document.body.appendChild(script)
  }
}

export const openAppziSurvey = (id: AppziSurveyIdType, data: AppziEventParamsTypes = {}) => {
  if (!isProduction) {
    return
  }

  if (window.appziSettings) {
    window.appziSettings = {
      data,
    }
  }

  if (window.appzi) {
    window.appzi.openSurvey(id)
  }
}

export const onOpenAppziSurvey = (id: AppziSurveyIdType, data?: AppziEventParamsTypes) => {
  return (event?: SyntheticEvent) => {
    if (!isProduction) {
      return
    }

    event?.stopPropagation()

    openAppziSurvey(id, data)
  }
}
